import LeadsStepper from './LeadsStepper.component';

export default LeadsStepper;
